import type { ReactNode } from 'react';

import type { IconValue } from '@playbooks/ui/components/icon';

import { CommentFeedback } from './comment-feedback';
import { ContentFeedback } from './content-feedback';
import { DisplayFeedback } from './display-feedback';
import { DropFeedback } from './drop-feedback';
import { FileFeedback } from './file-feedback';
import { ListFeedback } from './list-feedback';
import { ModalFeedback } from './modal-feedback';
import { PageFeedback } from './page-feedback';
import { PillFeedback } from './pill-feedback';
import { PreviewFeedback } from './preview-feedback';
import { SearchFeedback } from './search-feedback';
import { SectionFeedback } from './section-feedback';
import { SelectFeedback } from './select-feedback';
import { TableFeedback } from './table-feedback';

type FeedbackLayout =
	| 'comment'
	| 'content'
	| 'display'
	| 'drop'
	| 'file'
	| 'list'
	| 'modal'
	| 'page'
	| 'pill'
	| 'preview'
	| 'search'
	| 'section'
	| 'select'
	| 'table';

interface FeedbackProps {
	layout: FeedbackLayout;
	density?: 'default' | 'compact';
	icon?: IconValue;
	title?: ReactNode;
	text?: ReactNode;
	actions?: ReactNode;
	variant?: 'default' | 'success' | 'destructive';
	className?: string;
}

const Feedback = ({ layout, density, icon, title, text, actions, variant, className }: FeedbackProps) => {
	// Props
	const props = { density, icon, title, text, actions, variant, className };
	switch (layout) {
		case 'display':
			return <DisplayFeedback {...props} />;

		case 'comment':
			return <CommentFeedback {...props} />;

		case 'content':
			return <ContentFeedback {...props} />;

		case 'drop':
			return <DropFeedback {...props} />;

		case 'file':
			return <FileFeedback {...props} />;

		case 'list':
			return <ListFeedback {...props} />;

		case 'modal':
			return <ModalFeedback {...props} />;

		case 'page':
			return <PageFeedback {...props} />;

		case 'pill':
			return <PillFeedback {...props} />;

		case 'preview':
			return <PreviewFeedback {...props} />;

		case 'search':
			return <SearchFeedback {...props} />;

		case 'section':
			return <SectionFeedback {...props} />;

		case 'select':
			return <SelectFeedback {...props} />;

		case 'table':
			return <TableFeedback {...props} />;
	}
};

export { Feedback };
export type { FeedbackLayout, FeedbackProps };
